import * as React from "react";
import styled, { css } from "styled-components";
import { Alert, Row, Col } from "components/bootstrap";
import Icon from "components/common/Icon";
const StyledAlert = styled(Alert)(
  ({ theme }) => css`
    margin-top: ${theme.spacings.sm};
  `
);
const NotificationList = styled.ul(
  ({ theme }) => css`
    list-style: none;
    margin: 0;
    padding: 0;

    > li {
      display: flex;
      align-items: center;
      margin-bottom: ${theme.spacings.xs};
    }

    > li:last-child {
      margin-bottom: 0;
    }
  `
);
const DangerIcon = styled(Icon)(
  ({ theme }) => css`
    color: ${theme.colors.variant.danger};
    margin-right: ${theme.spacings.xs};
  `
);
const WarningIcon = styled(Icon)(
  ({ theme }) => css`
    color: ${theme.colors.variant.warning};
    margin-right: ${theme.spacings.xs};
  `
);
const ICON_BY_SEVERITY = {
  danger: DangerIcon,
  warning: WarningIcon
};
const NotificationBanner = ({ title, items }) => {
  if (items.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "info", noIcon: true, title }, /* @__PURE__ */ React.createElement(NotificationList, null, items.map((item, index) => {
    var _a;
    const SeverityIcon = ICON_BY_SEVERITY[item.severity];
    const key = (_a = item.id) != null ? _a : typeof item.message === "string" ? item.message : `${item.severity}-${index}`;
    return /* @__PURE__ */ React.createElement("li", { key }, /* @__PURE__ */ React.createElement(SeverityIcon, { name: "error" }), /* @__PURE__ */ React.createElement("span", null, item.message));
  })))));
};
export default NotificationBanner;
